import { render, staticRenderFns } from "./DasboardPartner.vue?vue&type=template&id=ba3bd084&"
import script from "./DasboardPartner.vue?vue&type=script&lang=js&"
export * from "./DasboardPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports